module.exports = __webpack_public_path__ + "components/rewards/isobaa/static/icon-9c90746ff5738d2da109ea2d56426f53.png";